var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        title: "Generate Newsletter Link",
        visible: _vm.dialogVisible,
        scrollbar: false,
        width: _vm.upload ? "600px" : "1000px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.onClosed,
      },
    },
    [
      _vm.dialogVisible
        ? [
            _vm.upload
              ? [
                  _c(
                    "div",
                    { staticClass: "main" },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            action: "",
                            "http-request": _vm.customUpload,
                            "on-remove": _vm.handleRemove,
                            "on-error": _vm.onError,
                            "before-upload": _vm.beforeUpload,
                            multiple: "",
                            accept: ".html,.pdf,.mp4,.pptx",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-right": "30px" },
                                  attrs: {
                                    size: "small",
                                    icon: "el-icon-plus",
                                    type: "primary",
                                  },
                                },
                                [_vm._v(" Choose File ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "box",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        "margin-right": "10px",
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "red" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v(" 文件是否可下载"),
                                    ]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: { label: 1 },
                                      model: {
                                        value: _vm.isDownload,
                                        callback: function ($$v) {
                                          _vm.isDownload = $$v
                                        },
                                        expression: "isDownload",
                                      },
                                    },
                                    [_vm._v("Yes")]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: { label: 0 },
                                      model: {
                                        value: _vm.isDownload,
                                        callback: function ($$v) {
                                          _vm.isDownload = $$v
                                        },
                                        expression: "isDownload",
                                      },
                                    },
                                    [_vm._v("No")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Only html/pdf/mp4/pptx files can be uploaded"
                                ),
                              ]),
                              _c("span", { staticClass: "red" }, [
                                _vm._v(
                                  " Total: " +
                                    _vm._s(_vm.uploadList.length) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSave },
                        },
                        [_vm._v(" Submit")]
                      ),
                      _c("el-button", { on: { click: _vm.onClosed } }, [
                        _vm._v(" Cancel "),
                      ]),
                    ],
                    1
                  ),
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "main" },
                    [
                      _c(
                        "div",
                        { staticClass: "el-upload__tip" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "iconfont icon-export",
                                loading: _vm.exporting,
                              },
                              on: { click: _vm.download },
                            },
                            [_vm._v(" Export ")]
                          ),
                          _c("span", { staticClass: "red" }, [
                            _vm._v(
                              " Total: " + _vm._s(_vm.uploadList.length) + " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        { attrs: { data: _vm.tableData } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "OriginalName",
                              label: "File Name",
                              width: "150",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "FilePath",
                              label: "Newsletter Link",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }